import { useState } from 'react';
import Card from '@raydiant/raydial/components/Card';
import Text from '@raydiant/raydial/components/Text';
import DisplaiAcademyImage from './images/displai-academy.svg';
import { XMark } from '@raydiant/raydial/components/Icons';
import Button from '@raydiant/raydial/components/Button';

const DisplaiAcademyCard = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleOpenVideo = () => {
    setIsVideoOpen(true);
  };

  const handleCloseVideo = () => {
    setIsVideoOpen(false);
  };

  return (
    <>
      <Card className="w-full xl:max-w-[628px] p-0">
        <div className="flex flex-col gap-1 pt-8 px-6 pb-4">
          <Text className="text-black" variant="subheader">
            Discover, Learn, Displai
          </Text>
          <Text className="font-normal" variant="smallSubtitle">
            Learn how to get the most out of Displai
          </Text>
        </div>

        <div
          className="relative bg-blue-100 overflow-hidden cursor-pointer hover:opacity-90 transition-opacity"
          onClick={handleOpenVideo}
        >
          <img
            src={DisplaiAcademyImage}
            alt="Displai Academy"
            className="w-full h-auto"
          />
        </div>

        <div className="pt-6" />
      </Card>

      {/* Video Overlay Modal */}
      {isVideoOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          onClick={handleCloseVideo}
        >
          <div
            className="relative w-full max-w-4xl mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <Button
              variant="unstyled"
              onPress={handleCloseVideo}
              className="absolute -top-8 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
              aria-label="Close video"
            >
              <XMark size={16} />
            </Button>

            {/* YouTube Video */}
            <div className="relative aspect-video">
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/iwLv2CDioF8?autoplay=1"
                title="Displai Academy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DisplaiAcademyCard;
